import { getTemplateSpreadsheetId, type TemplateName } from './projectTemplates';

export const DEFAULT_TEMPLATE_NAME: TemplateName = 'Roller - Feature - Hebrew';

export interface TemplateSheetSource {
  kind: 'template';
  templateName: TemplateName;
  spreadsheetId: string;
}

export interface ProjectSheetSource {
  kind: 'project';
  projectId: string;
}

export type InitialSheetSource = TemplateSheetSource | ProjectSheetSource;

export type CreationSheetSourceValue = `template:${TemplateName}` | `project:${string}`;

export function getTemplateCreationSourceValue(templateName: TemplateName): CreationSheetSourceValue {
  return `template:${templateName}`;
}

export function getProjectCreationSourceValue(projectId: string): CreationSheetSourceValue {
  return `project:${projectId}`;
}

export function getInitialSheetSource(value: CreationSheetSourceValue): InitialSheetSource {
  if (value.startsWith('project:')) {
    return {
      kind: 'project',
      projectId: value.slice('project:'.length),
    };
  }

  const templateName: TemplateName = value.slice('template:'.length) as TemplateName;
  return {
    kind: 'template',
    templateName,
    spreadsheetId: getTemplateSpreadsheetId(templateName),
  };
}

export function getCreationSourceAnalytics(source: InitialSheetSource): Record<string, string> {
  if (source.kind === 'project') {
    return {
      source_type: 'project',
      source_project_id: source.projectId,
    };
  }

  return {
    source_type: 'template',
    template_name: source.templateName,
  };
}
